export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  categoryName: string;
  description: string;
  longDescription: string;
  status: string;
  rating: number;
  views: number;
  favorites: number;
  tags: string[];
  chapters: ComicChapter[];
  updatedAt: string;
  createdAt: string;
}

export const comics: Comic[] = [
  {
    id: 'her-secret-garden',
    title: '她的秘密花园',
    author: '金秀雅',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20cover%20featuring%20a%20young%20woman%20in%20a%20romantic%20garden%20setting%20with%20soft%20pastel%20flowers%20and%20warm%20sunlight%2C%20watercolor%20illustration%20style%2C%20delicate%20and%20dreamy%20atmosphere%2C%20Korean%20manhwa%20art%20style%2C%20soft%20pink%20and%20cream%20tones&width=600&height=800&seq=comic-01&orientation=portrait',
    category: 'romance',
    categoryName: '恋爱',
    description: '一个关于暗恋与成长的温暖故事，平凡女孩与校园男神之间悄然绽放的秘密恋情。',
    longDescription: '平凡的大二学生林小婉，在一次偶然的校园活动中邂逅了全校公认的校草韩俊熙。本以为只是擦肩而过的缘分，却因为一本遗失的日记本，两人的人生轨迹开始交织。在这个充满秘密的花园里，一段关于暗恋、成长与勇气的温暖故事悄然展开。当秘密被揭开的那一刻，两颗心能否跨越所有障碍走到一起？',
    status: '连载中',
    rating: 9.2,
    views: 1285000,
    favorites: 86500,
    tags: ['纯爱', '校园', '治愈', '暗恋'],
    chapters: [
      { id: 'ch1', title: '第1话 命运的相遇', number: 1, updatedAt: '2026-08-01' },
      { id: 'ch2', title: '第2话 遗失的日记本', number: 2, updatedAt: '2026-07-25' },
      { id: 'ch3', title: '第3话 图书馆的秘密', number: 3, updatedAt: '2026-07-18' },
      { id: 'ch4', title: '第4话 雨中的约定', number: 4, updatedAt: '2026-07-11' },
      { id: 'ch5', title: '第5话 心跳的距离', number: 5, updatedAt: '2026-07-04' },
      { id: 'ch6', title: '第6话 樱花树下的告白', number: 6, updatedAt: '2026-06-27' },
      { id: 'ch7', title: '第7话 另一个她', number: 7, updatedAt: '2026-06-20' },
      { id: 'ch8', title: '第8话 无法说出口的话', number: 8, updatedAt: '2026-06-13' },
    ],
    updatedAt: '2026-08-01',
    createdAt: '2026-06-01',
  },
  {
    id: 'heart-signal',
    title: '心动信号',
    author: '李恩智',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20cover%20illustration%20of%20a%20couple%20sharing%20earphones%20on%20a%20subway%20train%2C%20warm%20evening%20light%20streaming%20through%20windows%2C%20romantic%20urban%20atmosphere%2C%20Korean%20manhwa%20style%2C%20soft%20warm%20orange%20and%20cream%20color%20palette&width=600&height=800&seq=comic-02&orientation=portrait',
    category: 'romance',
    categoryName: '恋爱',
    description: '城市地铁里的偶然邂逅，一个耳机连接了两颗孤独的心，心动信号正在传递中。',
    longDescription: '每天乘坐同一班地铁的广告设计师金智勋，偶然与戴着同款耳机的音乐制作人姜素拉四目相对。从借耳机开始的一段奇妙缘分，让两个疲惫的都市灵魂在城市的地下铁中找到了彼此的频率。但现实的种种阻碍，能否让这段因音乐而生的感情奏响完美的终章？',
    status: '连载中',
    rating: 9.0,
    views: 1080000,
    favorites: 72300,
    tags: ['都市', '职场', '音乐', '浪漫'],
    chapters: [
      { id: 'ch1', title: '第1话 同款耳机', number: 1, updatedAt: '2026-07-30' },
      { id: 'ch2', title: '第2话 你的歌单', number: 2, updatedAt: '2026-07-23' },
      { id: 'ch3', title: '第3话 深夜电台', number: 3, updatedAt: '2026-07-16' },
      { id: 'ch4', title: '第4话 不期而遇', number: 4, updatedAt: '2026-07-09' },
      { id: 'ch5', title: '第5话 旋律中的秘密', number: 5, updatedAt: '2026-07-02' },
      { id: 'ch6', title: '第6话 为你写的歌', number: 6, updatedAt: '2026-06-25' },
    ],
    updatedAt: '2026-07-30',
    createdAt: '2026-05-15',
  },
  {
    id: 'magic-apprentice',
    title: '魔法学徒日记',
    author: '朴志浩',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20webtoon%20cover%20showing%20a%20young%20apprentice%20holding%20a%20glowing%20magical%20book%20in%20an%20ancient%20library%2C%20floating%20spell%20runes%20and%20magical%20particles%2C%20warm%20candlelight%20atmosphere%2C%20Korean%20manhwa%20art%20style%2C%20mystical%20golden%20and%20deep%20green%20tones&width=600&height=800&seq=comic-03&orientation=portrait',
    category: 'fantasy',
    categoryName: '奇幻',
    description: '普通高中生意外进入魔法学院，在古老图书馆中发现了改变命运的魔法书。',
    longDescription: '高中生崔宇真在一次雷雨夜无意间触发了祖母留下的古书，被卷入了一个隐藏在现代世界中的魔法学院。在这里，他发现自己拥有罕见的元素操控天赋，但也因此卷入了光明与黑暗势力之间的千年纷争。从菜鸟学徒到传说中的天命之人，他的魔法之旅才刚刚开始。',
    status: '连载中',
    rating: 9.5,
    views: 2150000,
    favorites: 134200,
    tags: ['魔法', '学院', '冒险', '成长'],
    chapters: [
      { id: 'ch1', title: '第1话 雷雨夜的召唤', number: 1, updatedAt: '2026-08-03' },
      { id: 'ch2', title: '第2话 隐世学院', number: 2, updatedAt: '2026-07-27' },
      { id: 'ch3', title: '第3话 元素试炼', number: 3, updatedAt: '2026-07-20' },
      { id: 'ch4', title: '第4话 禁书区的秘密', number: 4, updatedAt: '2026-07-13' },
      { id: 'ch5', title: '第5话 暗影来袭', number: 5, updatedAt: '2026-07-06' },
      { id: 'ch6', title: '第6话 古老的预言', number: 6, updatedAt: '2026-06-29' },
      { id: 'ch7', title: '第7话 第一次战斗', number: 7, updatedAt: '2026-06-22' },
      { id: 'ch8', title: '第8话 觉醒的力量', number: 8, updatedAt: '2026-06-15' },
      { id: 'ch9', title: '第9话 盟友与敌人', number: 9, updatedAt: '2026-06-08' },
    ],
    updatedAt: '2026-08-03',
    createdAt: '2026-04-01',
  },
  {
    id: 'dragon-heir',
    title: '龙之继承者',
    author: '崔敏俊',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20webtoon%20cover%20featuring%20a%20warrior%20with%20dragon%20scale%20armor%20standing%20on%20a%20mountain%20peak%2C%20a%20massive%20dragon%20silhouette%20in%20the%20background%2C%20epic%20fantasy%20illustration%2C%20Korean%20manhwa%20style%2C%20dramatic%20sky%20with%20golden%20and%20crimson%20clouds&width=600&height=800&seq=comic-04&orientation=portrait',
    category: 'fantasy',
    categoryName: '奇幻',
    description: '龙族末裔少年踏上寻找失落龙魂的冒险之旅，揭开被尘封千年的古老传说。',
    longDescription: '在龙族几乎灭绝的世界里，少年卡伊尔是最后的龙之继承者。为了唤醒体内沉睡的龙魂，他必须踏上危险的旅程，寻找散落在世界各地的龙之碎片。一路上，他遇到了忠诚的伙伴、狡猾的敌人，以及隐藏在历史背后的惊人真相。当最后的龙魂被唤醒，他将面临一个改变世界的选择。',
    status: '连载中',
    rating: 9.3,
    views: 1860000,
    favorites: 115800,
    tags: ['龙族', '冒险', '史诗', '奇幻'],
    chapters: [
      { id: 'ch1', title: '第1话 最后的龙裔', number: 1, updatedAt: '2026-07-28' },
      { id: 'ch2', title: '第2话 启程之日', number: 2, updatedAt: '2026-07-21' },
      { id: 'ch3', title: '第3话 荒漠中的遗迹', number: 3, updatedAt: '2026-07-14' },
      { id: 'ch4', title: '第4话 炎之试炼', number: 4, updatedAt: '2026-07-07' },
      { id: 'ch5', title: '第5话 影之刺客', number: 5, updatedAt: '2026-06-30' },
    ],
    updatedAt: '2026-07-28',
    createdAt: '2026-05-20',
  },
  {
    id: 'night-hunter',
    title: '暗夜猎手',
    author: '郑宇成',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20action%20Korean%20webtoon%20cover%20showing%20a%20mysterious%20hunter%20in%20a%20long%20black%20coat%20on%20a%20rainy%20city%20street%20at%20night%2C%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20noir%20atmosphere%2C%20Korean%20manhwa%20style%2C%20deep%20blue%20and%20crimson%20accents&width=600&height=800&seq=comic-05&orientation=portrait',
    category: 'action',
    categoryName: '动作',
    description: '夜幕降临，猎人觉醒。一个背负血海深仇的男人，在都市暗影中展开猎杀。',
    longDescription: '前特种部队成员姜泰浩，在一次神秘任务中失去了所有战友。三年后，他以"暗夜猎手"的身份重新出现在首尔的黑暗中，追查那场悲剧背后的真相。每一个夜晚都是一场生死对决，每一个线索都指向一个庞大的地下组织。当他越来越接近真相时，才发现自己早已成为别人棋局中的一枚棋子。',
    status: '连载中',
    rating: 9.4,
    views: 1760000,
    favorites: 97800,
    tags: ['动作', '悬疑', '复仇', '都市'],
    chapters: [
      { id: 'ch1', title: '第1话 夜之序幕', number: 1, updatedAt: '2026-08-02' },
      { id: 'ch2', title: '第2话 血之契约', number: 2, updatedAt: '2026-07-26' },
      { id: 'ch3', title: '第3话 地下拳场', number: 3, updatedAt: '2026-07-19' },
      { id: 'ch4', title: '第4话 线人', number: 4, updatedAt: '2026-07-12' },
      { id: 'ch5', title: '第5话 追击战', number: 5, updatedAt: '2026-07-05' },
      { id: 'ch6', title: '第6话 幕后之手', number: 6, updatedAt: '2026-06-28' },
      { id: 'ch7', title: '第7话 过去的幽灵', number: 7, updatedAt: '2026-06-21' },
    ],
    updatedAt: '2026-08-02',
    createdAt: '2026-04-15',
  },
  {
    id: 'martial-supreme',
    title: '武道至尊',
    author: '安在赫',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20martial%20arts%20Korean%20webtoon%20cover%20featuring%20a%20fighter%20in%20traditional%20martial%20arts%20attire%20mid-action%20with%20dynamic%20energy%20effects%2C%20ancient%20temple%20background%2C%20powerful%20and%20intense%20atmosphere%2C%20Korean%20manhwa%20style%2C%20warm%20earth%20tones%20with%20golden%20energy%20streaks&width=600&height=800&seq=comic-06&orientation=portrait',
    category: 'action',
    categoryName: '动作',
    description: '被废掉武功的天才武者，凭借不屈意志重登武道巅峰的热血故事。',
    longDescription: '曾经的武道天才韩振宇，在一次宗门内斗中被废去全身经脉，沦为废人。所有人都以为他的武道之路已经终结，但他却在绝境中领悟了失传已久的「逆天诀」。重塑经脉、重练武功，他发誓要夺回属于自己的一切。在这条布满荆棘的复仇之路上，他将遇到什么样的对手和盟友？',
    status: '连载中',
    rating: 9.1,
    views: 1520000,
    favorites: 89300,
    tags: ['武道', '热血', '复仇', '成长'],
    chapters: [
      { id: 'ch1', title: '第1话 陨落的天才', number: 1, updatedAt: '2026-07-31' },
      { id: 'ch2', title: '第2话 绝境逢生', number: 2, updatedAt: '2026-07-24' },
      { id: 'ch3', title: '第3话 逆天诀', number: 3, updatedAt: '2026-07-17' },
      { id: 'ch4', title: '第4话 重返宗门', number: 4, updatedAt: '2026-07-10' },
      { id: 'ch5', title: '第5话 一雪前耻', number: 5, updatedAt: '2026-07-03' },
      { id: 'ch6', title: '第6话 天外有天', number: 6, updatedAt: '2026-06-26' },
    ],
    updatedAt: '2026-07-31',
    createdAt: '2026-05-10',
  },
  {
    id: 'seventh-missing',
    title: '第七个失踪者',
    author: '刘智媛',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20thriller%20Korean%20webtoon%20cover%20depicting%20a%20detective%20examining%20evidence%20on%20a%20foggy%20street%2C%20mysterious%20silhouette%20in%20the%20distance%2C%20tense%20and%20suspenseful%20mood%2C%20Korean%20manhwa%20style%2C%20muted%20gray%20tones%20with%20stark%20red%20details&width=600&height=800&seq=comic-07&orientation=portrait',
    category: 'thriller',
    categoryName: '悬疑',
    description: '六个人接连失踪，第七个目标是谁？刑警与时间赛跑的惊悚追凶之旅。',
    longDescription: '首尔江南区接连发生失踪案件，六名受害者在毫无关联的情况下消失得无影无踪。刑警张瑞妍在调查过程中发现，所有失踪者都与十年前一桩未破的灭门案有着千丝万缕的联系。当第七个失踪者出现时，她意识到凶手正在按照某种仪式完成最后的拼图。而她自己，似乎也已被列入凶手的名单之中。',
    status: '已完结',
    rating: 9.6,
    views: 2390000,
    favorites: 156200,
    tags: ['悬疑', '犯罪', '推理', '惊悚'],
    chapters: [
      { id: 'ch1', title: '第1话 消失的上班族', number: 1, updatedAt: '2026-06-15' },
      { id: 'ch2', title: '第2话 第二个受害者', number: 2, updatedAt: '2026-06-08' },
      { id: 'ch3', title: '第3话 十年前的案件', number: 3, updatedAt: '2026-06-01' },
      { id: 'ch4', title: '第4话 死亡密码', number: 4, updatedAt: '2026-05-25' },
      { id: 'ch5', title: '第5话 第六个', number: 5, updatedAt: '2026-05-18' },
      { id: 'ch6', title: '第6话 凶手的留言', number: 6, updatedAt: '2026-05-11' },
      { id: 'ch7', title: '第7话 最后的猎物', number: 7, updatedAt: '2026-05-04' },
      { id: 'ch8', title: '第8话 真相（终章）', number: 8, updatedAt: '2026-04-27' },
    ],
    updatedAt: '2026-06-15',
    createdAt: '2026-03-01',
  },
  {
    id: 'midnight-clinic',
    title: '午夜诊所',
    author: '韩素英',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mystery%20Korean%20webtoon%20cover%20showing%20a%20doctor%20in%20white%20coat%20standing%20in%20a%20dimly%20lit%20clinic%20hallway%20at%20night%2C%20eerie%20green%20light%20from%20exit%20sign%2C%20mysterious%20medical%20setting%2C%20Korean%20manhwa%20style%2C%20cold%20clinical%20tones%20with%20unsettling%20atmosphere&width=600&height=800&seq=comic-08&orientation=portrait',
    category: 'thriller',
    categoryName: '悬疑',
    description: '只在午夜开门的神秘诊所，治疗的不仅是身体，还有不为人知的秘密。',
    longDescription: '在首尔老城区一条不起眼的巷子里，有一家只在午夜零点到凌晨三点营业的诊所。年轻医生尹智恩是这里唯一的主治医师。来就诊的病人们都有着不同寻常的症状——有人说能看到别人的记忆，有人说自己的影子会自己移动。随着一个个病例的展开，尹智恩发现这些病人之间存在着某种诡异的联系，而她自己也被卷入了一个超乎想象的谜团之中。',
    status: '连载中',
    rating: 9.3,
    views: 1430000,
    favorites: 78200,
    tags: ['悬疑', '奇幻', '医学', '超自然'],
    chapters: [
      { id: 'ch1', title: '第1话 午夜零时', number: 1, updatedAt: '2026-07-29' },
      { id: 'ch2', title: '第2话 第一个病人', number: 2, updatedAt: '2026-07-22' },
      { id: 'ch3', title: '第3话 影子症候群', number: 3, updatedAt: '2026-07-15' },
      { id: 'ch4', title: '第4话 记忆的碎片', number: 4, updatedAt: '2026-07-08' },
      { id: 'ch5', title: '第5话 不眠者', number: 5, updatedAt: '2026-07-01' },
    ],
    updatedAt: '2026-07-29',
    createdAt: '2026-06-10',
  },
  {
    id: 'loser-reverse',
    title: '废柴逆袭记',
    author: '宋智勋',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20comedy%20Korean%20webtoon%20cover%20showing%20a%20goofy%20office%20worker%20with%20a%20surprised%20expression%20surrounded%20by%20chaotic%20office%20items%2C%20bright%20and%20energetic%20illustration%2C%20Korean%20manhwa%20style%2C%20vibrant%20warm%20colors%20and%20playful%20composition&width=600&height=800&seq=comic-09&orientation=portrait',
    category: 'comedy',
    categoryName: '喜剧',
    description: '职场最底层废柴意外获得超能力，从此开启啼笑皆非的逆袭人生。',
    longDescription: '在公司混了五年的底层社畜金大雄，业绩垫底、人缘极差、还被女朋友甩了。在他人生最绝望的那天，一道闪电劈中了他——从此他获得了"让任何人说实话"的超能力。本想用这能力在职场翻身，结果却引发了一连串让人捧腹的连锁反应。当整个公司的人都开始说实话，这个世界还会正常运转吗？',
    status: '连载中',
    rating: 8.9,
    views: 1650000,
    favorites: 91600,
    tags: ['喜剧', '职场', '超能力', '搞笑'],
    chapters: [
      { id: 'ch1', title: '第1话 史上最惨的一天', number: 1, updatedAt: '2026-08-04' },
      { id: 'ch2', title: '第2话 被雷劈了？', number: 2, updatedAt: '2026-07-28' },
      { id: 'ch3', title: '第3话 老板的真话', number: 3, updatedAt: '2026-07-21' },
      { id: 'ch4', title: '第4话 全公司大乱', number: 4, updatedAt: '2026-07-14' },
      { id: 'ch5', title: '第5话 意想不到的后台', number: 5, updatedAt: '2026-07-07' },
      { id: 'ch6', title: '第6话 升职加薪之路', number: 6, updatedAt: '2026-06-30' },
    ],
    updatedAt: '2026-08-04',
    createdAt: '2026-05-05',
  },
  {
    id: 'office-romance-ban',
    title: '社内恋爱禁止条例',
    author: '朴美妍',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20comedy%20Korean%20webtoon%20cover%20depicting%20two%20office%20workers%20hiding%20their%20relationship%20behind%20office%20cubicles%2C%20secret%20glances%20and%20blushing%20expressions%2C%20bright%20modern%20office%20setting%2C%20Korean%20manhwa%20style%2C%20warm%20and%20cheerful%20pastel%20tones&width=600&height=800&seq=comic-10&orientation=portrait',
    category: 'comedy',
    categoryName: '喜剧',
    description: '禁止办公室恋爱的公司里，两位部门主管的秘密恋情引发的一系列爆笑事件。',
    longDescription: '在韩国最严格的跨国公司里，有一条铁律——禁止员工之间谈恋爱，违者立即开除。然而，市场部的女神主管李夏琳和开发部的天才主管金泰亨却秘密恋爱了整整两年。为了不被发现，两人在公司里上演了一出出啼笑皆非的"陌生人"戏码。但纸终究包不住火，当他们的秘密面临暴露危机时，一场轰轰烈烈的办公室保卫战就此拉开序幕。',
    status: '连载中',
    rating: 9.0,
    views: 1380000,
    favorites: 80200,
    tags: ['恋爱', '职场', '喜剧', '秘密恋爱'],
    chapters: [
      { id: 'ch1', title: '第1话 禁止恋爱的公司', number: 1, updatedAt: '2026-07-27' },
      { id: 'ch2', title: '第2话 秘密的午餐', number: 2, updatedAt: '2026-07-20' },
      { id: 'ch3', title: '第3话 差点暴露', number: 3, updatedAt: '2026-07-13' },
      { id: 'ch4', title: '第4话 公司团建的危机', number: 4, updatedAt: '2026-07-06' },
      { id: 'ch5', title: '第5话 新同事的怀疑', number: 5, updatedAt: '2026-06-29' },
    ],
    updatedAt: '2026-07-27',
    createdAt: '2026-05-25',
  },
  {
    id: 'rebirth-heiress',
    title: '重生之豪门千金',
    author: '张瑞希',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20drama%20Korean%20webtoon%20cover%20featuring%20an%20elegant%20woman%20in%20a%20luxurious%20gown%20standing%20in%20a%20grand%20mansion%20hallway%2C%20sophisticated%20and%20dramatic%20atmosphere%2C%20Korean%20manhwa%20style%2C%20rich%20burgundy%20and%20gold%20tones%20with%20dramatic%20lighting&width=600&height=800&seq=comic-11&orientation=portrait',
    category: 'drama',
    categoryName: '剧情',
    description: '被陷害至死的豪门千金重生回到三年前，这一次她要改写自己的命运。',
    longDescription: '沈若兰是沈氏集团的掌上明珠，却在新婚之夜被丈夫与闺蜜联手陷害，含恨而终。当她再次睁开眼睛，发现自己回到了三年前——一切都还没发生的时候。带着前世的记忆和刻骨铭心的仇恨，她决定不再做那个天真善良的沈若兰。这一次，她要让所有伤害过她的人付出代价，同时守护那些真正爱她的人。',
    status: '已完结',
    rating: 9.4,
    views: 2780000,
    favorites: 189500,
    tags: ['重生', '豪门', '复仇', '女性'],
    chapters: [
      { id: 'ch1', title: '第1话 死亡与重生', number: 1, updatedAt: '2026-05-20' },
      { id: 'ch2', title: '第2话 回到三年前', number: 2, updatedAt: '2026-05-13' },
      { id: 'ch3', title: '第3话 第一步棋', number: 3, updatedAt: '2026-05-06' },
      { id: 'ch4', title: '第4话 商场上的交锋', number: 4, updatedAt: '2026-04-29' },
      { id: 'ch5', title: '第5话 闺蜜的真面目', number: 5, updatedAt: '2026-04-22' },
      { id: 'ch6', title: '第6话 前世的恩人', number: 6, updatedAt: '2026-04-15' },
      { id: 'ch7', title: '第7话 布局', number: 7, updatedAt: '2026-04-08' },
      { id: 'ch8', title: '第8话 复仇的开始', number: 8, updatedAt: '2026-04-01' },
      { id: 'ch9', title: '第9话 命运的转折', number: 9, updatedAt: '2026-03-25' },
      { id: 'ch10', title: '第10话 新的开始（终章）', number: 10, updatedAt: '2026-03-18' },
    ],
    updatedAt: '2026-05-20',
    createdAt: '2026-01-15',
  },
  {
    id: 'crossroads',
    title: '命运交叉点',
    author: '尹智慧',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20drama%20Korean%20webtoon%20cover%20showing%20two%20people%20walking%20past%20each%20other%20at%20a%20busy%20city%20intersection%2C%20dramatic%20split%20lighting%2C%20emotional%20and%20poignant%20atmosphere%2C%20Korean%20manhwa%20style%2C%20warm%20sunset%20orange%20and%20deep%20shadow%20contrast&width=600&height=800&seq=comic-12&orientation=portrait',
    category: 'drama',
    categoryName: '剧情',
    description: '在人生的十字路口，四个陌生人的命运意外交织，谱写出一段温暖而深刻的故事。',
    longDescription: '首尔弘大的一个十字路口，每天有数万人从这里经过。一个失去梦想的钢琴师、一个被家族抛弃的继承人、一个独自抚养孩子的单亲妈妈、一个隐瞒病情的医生——四个看似毫无交集的人，却在这个路口以一种奇妙的方式相遇了。他们的故事彼此交织，在命运的交叉点上重新找到了生活的意义和勇气。',
    status: '连载中',
    rating: 9.2,
    views: 1250000,
    favorites: 67400,
    tags: ['人生', '温情', '都市', '感动'],
    chapters: [
      { id: 'ch1', title: '第1话 十字路口', number: 1, updatedAt: '2026-07-26' },
      { id: 'ch2', title: '第2话 钢琴师', number: 2, updatedAt: '2026-07-19' },
      { id: 'ch3', title: '第3话 继承者', number: 3, updatedAt: '2026-07-12' },
      { id: 'ch4', title: '第4话 单亲妈妈', number: 4, updatedAt: '2026-07-05' },
      { id: 'ch5', title: '第5话 交汇', number: 5, updatedAt: '2026-06-28' },
    ],
    updatedAt: '2026-07-26',
    createdAt: '2026-06-01',
  },
  {
    id: 'first-love-rule',
    title: '初恋的法则',
    author: '金秀雅',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sweet%20romance%20Korean%20webtoon%20cover%20showing%20teenagers%20sitting%20on%20a%20school%20rooftop%20during%20sunset%2C%20blushing%20faces%20and%20gentle%20expressions%2C%20youthful%20and%20nostalgic%20atmosphere%2C%20Korean%20manhwa%20style%2C%20soft%20pink%20and%20golden%20sunset%20tones&width=600&height=800&seq=comic-13&orientation=portrait',
    category: 'romance',
    categoryName: '恋爱',
    description: '高冷学霸与活泼少女，在这场名为初恋的实验中，谁会先打破自己的法则？',
    longDescription: '全校第一的冷面学霸崔时宇，给自己定下了三条法则：不谈恋爱、不浪费时间、不理会无聊的人。但当他遇到转学生韩多美后，这三条法则一条接一条地被打破了。这个总是带着灿烂笑容的女孩，用一种他从未预料的方式闯入了他的生活。当理性与感性发生碰撞，当法则与心动相互拉扯，他会做出怎样的选择？',
    status: '连载中',
    rating: 9.1,
    views: 1120000,
    favorites: 69300,
    tags: ['校园', '青春', '甜宠', '初恋'],
    chapters: [
      { id: 'ch1', title: '第1话 转学生', number: 1, updatedAt: '2026-08-01' },
      { id: 'ch2', title: '第2话 同桌的你', number: 2, updatedAt: '2026-07-25' },
      { id: 'ch3', title: '第3话 图书馆值班', number: 3, updatedAt: '2026-07-18' },
      { id: 'ch4', title: '第4话 补习约定', number: 4, updatedAt: '2026-07-11' },
      { id: 'ch5', title: '第5话 运动会', number: 5, updatedAt: '2026-07-04' },
    ],
    updatedAt: '2026-08-01',
    createdAt: '2026-06-15',
  },
  {
    id: 'strange-world',
    title: '异世界归来的我',
    author: '朴志浩',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20webtoon%20cover%20showing%20a%20person%20stepping%20through%20a%20magical%20portal%20between%20two%20worlds%2C%20one%20side%20modern%20city%20the%20other%20fantasy%20landscape%2C%20surreal%20and%20dramatic%2C%20Korean%20manhwa%20style%2C%20contrasting%20cool%20blue%20and%20warm%20golden%20light&width=600&height=800&seq=comic-14&orientation=portrait',
    category: 'fantasy',
    categoryName: '奇幻',
    description: '在异世界当了十年勇者的他回到地球，却发现这里只过了三天。',
    longDescription: '普通大学生韩智浩被召唤到异世界，在那里他经历了十年的冒险，成为了打败魔王的传奇勇者。当他终于找到方法回到地球时，却发现地球只过了三天。带着满级的能力和十年的战斗经验，他本想重新做回普通大学生，但现实却不断把他卷入各种超自然事件中。当异世界的威胁开始渗透到地球，他必须再次挺身而出。',
    status: '连载中',
    rating: 9.3,
    views: 1980000,
    favorites: 127600,
    tags: ['异世界', '逆袭', '校园', '奇幻'],
    chapters: [
      { id: 'ch1', title: '第1话 回归', number: 1, updatedAt: '2026-08-02' },
      { id: 'ch2', title: '第2话 三日之后', number: 2, updatedAt: '2026-07-26' },
      { id: 'ch3', title: '第3话 隐藏的力量', number: 3, updatedAt: '2026-07-19' },
      { id: 'ch4', title: '第4话 第一个异常', number: 4, updatedAt: '2026-07-12' },
      { id: 'ch5', title: '第5话 来自异界的访客', number: 5, updatedAt: '2026-07-05' },
      { id: 'ch6', title: '第6话 地球的守护者', number: 6, updatedAt: '2026-06-28' },
    ],
    updatedAt: '2026-08-02',
    createdAt: '2026-05-01',
  },
  {
    id: 'strongest-mercenary',
    title: '最强佣兵',
    author: '郑宇成',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20action%20Korean%20webtoon%20cover%20showing%20a%20battle-hardened%20mercenary%20with%20scars%20holding%20a%20weapon%20in%20a%20war-torn%20landscape%2C%20intense%20and%20gritty%20atmosphere%2C%20Korean%20manhwa%20style%2C%20muted%20olive%20green%20and%20steel%20gray%20tones&width=600&height=800&seq=comic-15&orientation=portrait',
    category: 'action',
    categoryName: '动作',
    description: '传奇佣兵金盆洗手后，为了守护重要的人，不得不再次拿起武器。',
    longDescription: '被誉为"死神"的传奇佣兵姜哲民，在最后一次任务后选择隐退，开了一家小餐馆过着平静的生活。但好景不长，曾经的组织找上门来，以他收养的女儿为人质，逼迫他参与一场涉及国际犯罪集团的阴谋。为了守护来之不易的平凡生活，他必须再次披上战甲，面对那些比战场更可怕的敌人。',
    status: '连载中',
    rating: 9.2,
    views: 1320000,
    favorites: 75400,
    tags: ['佣兵', '动作', '守护', '热血'],
    chapters: [
      { id: 'ch1', title: '第1话 隐退的传奇', number: 1, updatedAt: '2026-07-25' },
      { id: 'ch2', title: '第2话 不速之客', number: 2, updatedAt: '2026-07-18' },
      { id: 'ch3', title: '第3话 最后的任务', number: 3, updatedAt: '2026-07-11' },
      { id: 'ch4', title: '第4话 地下世界', number: 4, updatedAt: '2026-07-04' },
      { id: 'ch5', title: '第5话 旧敌', number: 5, updatedAt: '2026-06-27' },
    ],
    updatedAt: '2026-07-25',
    createdAt: '2026-05-18',
  },
  {
    id: 'memory-fragments',
    title: '记忆碎片',
    author: '刘智媛',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20psychological%20thriller%20Korean%20webtoon%20cover%20showing%20a%20person%20looking%20into%20a%20shattered%20mirror%20with%20different%20reflections%2C%20fragmented%20and%20disorienting%20composition%2C%20Korean%20manhwa%20style%2C%20cold%20gray%20tones%20with%20stark%20white%20highlights&width=600&height=800&seq=comic-16&orientation=portrait',
    category: 'thriller',
    categoryName: '悬疑',
    description: '失忆的女人醒来后发现所有人都称她为杀人犯，她必须拼凑记忆碎片找出真相。',
    longDescription: '在一场车祸后，韩素珍失去了过去五年的全部记忆。当她醒来时，所有人看她的眼神都充满了恐惧——因为三年前，她涉嫌杀害了自己的丈夫，却因证据不足被释放。面对自己可能是杀人犯的事实，素珍决定亲自调查真相。但越是深入，她越发现自己的记忆与事实之间存在着诡异的矛盾。究竟是记忆出了问题，还是有人在精心布局？',
    status: '已完结',
    rating: 9.5,
    views: 2050000,
    favorites: 142300,
    tags: ['悬疑', '失忆', '犯罪', '心理'],
    chapters: [
      { id: 'ch1', title: '第1话 空白', number: 1, updatedAt: '2026-04-10' },
      { id: 'ch2', title: '第2话 镜中的陌生人', number: 2, updatedAt: '2026-04-03' },
      { id: 'ch3', title: '第3话 指控', number: 3, updatedAt: '2026-03-27' },
      { id: 'ch4', title: '第4话 照片里的线索', number: 4, updatedAt: '2026-03-20' },
      { id: 'ch5', title: '第5话 日记本', number: 5, updatedAt: '2026-03-13' },
      { id: 'ch6', title: '第6话 丈夫的秘密', number: 6, updatedAt: '2026-03-06' },
      { id: 'ch7', title: '第7话 真相浮现', number: 7, updatedAt: '2026-02-27' },
      { id: 'ch8', title: '第8话 最后的碎片（终章）', number: 8, updatedAt: '2026-02-20' },
    ],
    updatedAt: '2026-04-10',
    createdAt: '2026-01-01',
  },
  {
    id: 'roommate-not-human',
    title: '我的室友不是人',
    author: '宋智勋',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20funny%20supernatural%20Korean%20webtoon%20cover%20showing%20a%20normal%20person%20sharing%20an%20apartment%20with%20a%20ghost%20and%20a%20nine-tailed%20fox%20spirit%2C%20chaotic%20and%20humorous%20scene%2C%20Korean%20manhwa%20style%2C%20bright%20and%20playful%20colors%20with%20supernatural%20glow%20effects&width=600&height=800&seq=comic-17&orientation=portrait',
    category: 'comedy',
    categoryName: '喜剧',
    description: '租到超便宜公寓的社畜，发现室友分别是鬼魂和九尾狐的爆笑同居生活。',
    longDescription: '刚毕业的穷社畜林智秀，在首尔以不可思议的低价租到了一间三室一厅的公寓。入住第一天她就明白了为什么这么便宜——她的两位室友分别是一个爱看韩剧的女鬼和一只沉迷游戏的九尾狐。一只鬼、一只狐、一个人，三个完全不同次元的生物被迫同居，每天都上演着无法预测的爆笑闹剧。',
    status: '连载中',
    rating: 8.8,
    views: 1560000,
    favorites: 88300,
    tags: ['喜剧', '奇幻', '同居', '搞笑'],
    chapters: [
      { id: 'ch1', title: '第1话 超便宜公寓', number: 1, updatedAt: '2026-08-03' },
      { id: 'ch2', title: '第2话 鬼室友登场', number: 2, updatedAt: '2026-07-27' },
      { id: 'ch3', title: '第3话 九尾狐的秘密', number: 3, updatedAt: '2026-07-20' },
      { id: 'ch4', title: '第4话 韩剧之夜', number: 4, updatedAt: '2026-07-13' },
      { id: 'ch5', title: '第5话 外卖风波', number: 5, updatedAt: '2026-07-06' },
    ],
    updatedAt: '2026-08-03',
    createdAt: '2026-06-05',
  },
  {
    id: 'against-the-current',
    title: '逆流而上的你',
    author: '尹智慧',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20touching%20drama%20Korean%20webtoon%20cover%20showing%20a%20determined%20young%20woman%20walking%20against%20a%20crowd%20on%20a%20busy%20city%20street%2C%20inspirational%20and%20emotional%20atmosphere%2C%20Korean%20manhwa%20style%2C%20warm%20sunlight%20breaking%20through%20clouds&width=600&height=800&seq=comic-18&orientation=portrait',
    category: 'drama',
    categoryName: '剧情',
    description: '小镇女孩只身闯荡首尔，用坚韧和勇气对抗命运的励志成长故事。',
    longDescription: '从小渔村走出来的女孩高恩星，带着仅有的十万韩元来到了首尔。没有名校学历、没有人脉关系，她在这个冷漠的大都市里从最底层做起。便利店店员、餐厅服务员、快递分拣员……她做过无数份工作，却从未放弃过成为设计师的梦想。在无数个想放弃的夜晚，是那些同样在奋斗的朋友们给了她继续前进的勇气。这是一个关于梦想、坚持和友情的温暖故事。',
    status: '连载中',
    rating: 9.0,
    views: 1180000,
    favorites: 61200,
    tags: ['励志', '成长', '都市', '梦想'],
    chapters: [
      { id: 'ch1', title: '第1话 离开', number: 1, updatedAt: '2026-07-24' },
      { id: 'ch2', title: '第2话 首尔的第一个夜晚', number: 2, updatedAt: '2026-07-17' },
      { id: 'ch3', title: '第3话 便利店女孩', number: 3, updatedAt: '2026-07-10' },
      { id: 'ch4', title: '第4话 机会', number: 4, updatedAt: '2026-07-03' },
      { id: 'ch5', title: '第5话 失败与重生', number: 5, updatedAt: '2026-06-26' },
    ],
    updatedAt: '2026-07-24',
    createdAt: '2026-06-08',
  },
];

export function getComicsByCategory(slug: string): Comic[] {
  if (slug === 'all') return comics;
  return comics.filter(c => c.category === slug);
}

export function getComicById(id: string): Comic | undefined {
  return comics.find(c => c.id === id);
}

export function getRelatedComics(comic: Comic, count: number = 6): Comic[] {
  const sameCategory = comics.filter(c => c.category === comic.category && c.id !== comic.id);
  const others = comics.filter(c => c.category !== comic.category && c.id !== comic.id);
  return [...sameCategory, ...others].slice(0, count);
}

export function getPopularComics(count: number = 8): Comic[] {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, count);
}

export function getLatestComics(count: number = 8): Comic[] {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, count);
}